import React from 'react';
import { createRoot } from 'react-dom/client';
import { DigitalSamplingContainer } from '../../app/DigitalSamplingContainer';

const container = document.getElementById('digital-sampling-container');
if (!container) {
  throw new Error(
    'Could not find container element with id #digital-sampling-container',
  );
}
const root = createRoot(container);
root.render(<DigitalSamplingContainer />);
